import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastService } from './toast.service';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { IResponse } from '../shared/models/IResponse.model';
import { IASMModel } from '../shared/models/asm.model';

@Injectable({
  providedIn: 'root'
})
export class AsmService {

  constructor(private httpClient: HttpClient, private toastService: ToastService) { }

  uploadASM(asmData: IASMModel): Observable<boolean> {
    return this.httpClient.post(`${environment.api_base_url}asm/upload`, asmData, {}).pipe(
      map((item: IResponse<boolean>) => {
        if(item?.isError){
          console.log(item.message);
        }
        return item?.data || null;
      }),
      catchError(() => {
        this.toastService.showError("Error uploading ASM file");
        return of(null);
      })
    );
  }
}
